module.exports = __webpack_public_path__ + "static/media/ekriti.5f529b60.jpg";